<template>
  <div class="title-block">
    <div :class="title?'title':''">
      {{ title }}
      <slot name="info" />
      <span class="alertInfo">{{ alertInfo }}</span>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    alertInfo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {

    };
  },
};
</script>

<style lang='scss' scoped>
  .title{
    width:100%;
    font-size:17px;
    margin-bottom:16px;
    position: relative;
    display:flex;
    align-items: center;
    color:#000;
    font-weight: 600;
  }
  .title::before{
    content: "";
    width: 2px;
    height: 17px;
    background-color: #059E84;
    margin-right: 8px;
    display: inline-block;
  }
  .alertInfo{
    font-size:13px;
    font-weight: 400;
    margin-left:8px;
    color:#808792
  }
</style>
